import {ContactGetVendorsApiArg, useGetVendorsQuery} from "./contact-api";
import {useWorkflowIds} from "../../common/OrganizationConfig/useWorkflowIds";

export type GetVendorsQueryValues = {
  search?: string;
};

export const useGetVendors = ({search}: GetVendorsQueryValues) => {
  const {getVendorsWorkflowId} = useWorkflowIds();

  const args: ContactGetVendorsApiArg = {
    workflowId: getVendorsWorkflowId,
    values: {
      variables: {
        search: search ?? "",
      },
    },
  };

  const {data, isLoading, isSuccess, isError, error} = useGetVendorsQuery(args);

  return {
    contactsData: data?.outputs,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
